angular.module('aprima-core-ui').component('apMessageListItem', {
    bindings: {
        message: '<',
        narrow: '<?'
    },
    templateUrl: '/core-ui/views/directives/partials/apMessageListItem.html',
    controller: ['CurrentUser', function(CurrentUser) {
        'use strict';

        // this logic is in $onInit instead of $onChanges because it's meant to be used with one time bindings,
        // not with a changing object
        this.$onInit = function init() {
            var currentUserId = CurrentUser.get().userId;

            this.isRead = function isRead() {
                return this.message && (currentUserId === this.message.LastReadByUid);
            };
        };
    }]
});

